import React from "react";
import Video from "./video";

const ResVideo = (props) => {

  const desktopVideo = props.desktopVideo;
  const mobileVideo = props.mobileVideo?.filename != undefined && props.mobileVideo?.filename != "" ? props.mobileVideo : props.desktopVideo;

  const desktopPoster = props.desktopPoster;
  const mobilePoster = props.mobilePoster?.filename != undefined && props.mobilePoster?.filename != "" ? props.mobilePoster : props.desktopPoster;

  return (
    <>
    <div className={`${props.className ? props.className : `w-full h-full`}`}>
      <Video className={`${props.className ? props.className : `w-full h-full`} hidden lg:block object-cover isolate backface`} video={desktopVideo} poster={desktopPoster} />
      <Video className={`${props.className ? props.className : `w-full h-full`} lg:hidden object-cover isolate`} video={mobileVideo} poster={mobilePoster} />
      </div>
    </>
  );
};

export default ResVideo;
